export const clarityValuesMap = {
    I3: 10,
    I2: 20,
    I1: 30,
    SI2: 40,
    SI1: 50,
    VS2: 60,
    VS1: 70,
    VVS2: 80,
    VVS1: 90,
    IF: 100,
    FL: 110
};

export const colorValuesMap = {
    N: 10,
    M: 20,
    L: 30,
    K: 40,
    J: 50,
    I: 60,
    H: 70,
    G: 80,
    F: 90,
    E: 100,
    D: 110
};
